export default "__VITE_ASSET__ca3e567e__"